<script>
  import { filter } from "../stores.js";
  import Filter from "./Filter.svelte";
  import SingleHeader from "./SingleHeader.svelte";

  import Modal from "sv-bootstrap-modal";
  let isOpen = false;

  export let account;
  export let feeds;
  let feed;
  let imgFile = account.files.filter((d) => d.format === "Item Image")[0];
  $: if ($filter && filter !== "") {
    feed = feeds.filter((d) => d.metadata.identifier === $filter)[0];
  } else {
    feed = account;
  }
</script>

<style>
  .show {
    font-weight: normal;
  }

  .close {
    font-size: 3.5rem;
    color: #794DFF;
    text-shadow: none;
    opacity: 1;
  }

  .modal-header, .modal-body{
    border-bottom: none;
  }

  h4 {
    color:#794DFF;
    cursor:pointer;
  }

  @media (min-width: 576px) {

  }

</style>

<div class="row pt-2 pb-2 pd-3 header-container align-items-center h-100">

  <div class="col-md-1 col-6 justify-content-start">
        <img
        class="mr-2 ml-0"
        src={`https://archive.org/download/${account.metadata.identifier}/${imgFile.name}`}
        height="100px"
        width="auto"
        alt="logo" />
  </div>

  <div class="col-md-6 offset-md-2 col-12 order-md-1 order-2">

  <div class="d-flex flex-column flex-md-row w-100 align-items-center my-3 my-md-0">
    <Filter />
  </div>
</div>


<div class="col-md-1 offset-md-2 col-6 float-right order-md-3">
  <Modal bind:open={isOpen}>
    <div class="modal-header">
          <button type="button" class="close mr-1" on:click={() => (isOpen = false)}>
          <span aria-hidden="true">&times;</span>
          </button>
    </div>
  <div class="modal-body">
      <h3>RADIO QUARTIERE è una forma di socialità nata nella Milano in Quarantena della Primavera 2020. Una radio autoprodotta e senza palinsesto nata da un gruppo di amici che vivono nella zona Nord-Ovest della città che poi si è diffusa nel resto della città e poi nel globo con radio gemelle sparse in <a href="https://yamakan.place/beirut/">Libano</a>, <a href="https://yamakan.place/palestine/">Palestina</a>, <a href="https://yamakan.place/tunis/">Tunisia</a>...</h3>
      <h3>C’è stata la musica da condividere e ascoltare insieme, chi ha raccontato la città che rallentava, chi leggeva dei libri, chi trasmetteva spezzoni di film, chi mandava registrazioni e chi faceva dj set. Ci sono stati i saluti agli amici che ascoltavano dall’Italia e dal resto del mondo, i messaggi vocali, le dirette, i quiz, i consigli per cucinare e le informazioni per la sopravvivenza.</h3>
      <h3>Mancavano solo gli abbracci, ma chi l’ha ascoltata dice di aver sentito anche quelli.</h3>
      <h3>La radio ha interrotto le trasmissioni. Questo sito è un'archivio che raccoglie alcuni dei contributi che sono stati mandati in onda dal 10 Marzo al 12 Maggio 2020.</h3>
      <h3>Per info &#10230 <a href="mailto:radioquartiere@gmail.com">Email</a>.<br>
      Per aggiornamenti &#10230; <a href="https://t.me/radioquartiere">Telegram</a>.<br>
      <h3>Powered by <a href="https://openpod.abbiamoundominio.org/">OpenPod</a> and <a href="https://openpod.abbiamoundominio.org/">Archive.org</a>.</h3>
    </div>
  </Modal>

  <h4 class="text-right" on:click={()=> (isOpen = true)}>Info</h4>
  </div>
</div>

<div class="row">
<div class="col-12 col-md-12">
  {#if $filter}
    <SingleHeader
      compact
      podcast={feed.metadata}
      cover={feed.files.filter((d) => d.format === 'Item Image')[0]} />
  {:else}
    <div>
        <!-- {@html feed.metadata.description} -->
    </div>
  {/if}
</div>
</div>
